const getCellPadding = (cellPaddingRight, cellPaddingLeft) => {
  const newWidth = {
    paddingRight: cellPaddingRight ?? '8px',
    paddingLeft: cellPaddingLeft ?? '8px',
  };
  return newWidth;
};

const getWidth = fieldWidth => {
  const newWidth = fieldWidth ? { width: fieldWidth } : { width: '5%' };
  return newWidth;
};

export { getWidth, getCellPadding };
